import { useCallback } from 'react';
import { Slide, toast } from 'react-toastify';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

/**
 * Hook used to handle notification.
 */
export const useNotification = () => {
  function CustomNotification({ data }) {
    return (
      <div>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {data.title}
        </Typography>
        <Typography variant="body2">{data.content}</Typography>
      </div>
    );
  }

  CustomNotification.propTypes = {
    data: PropTypes.shape({ title: PropTypes.string.isRequired, content: PropTypes.string })
      .isRequired
  };

  const addNotification = useCallback(
    ({
      type,
      title,
      message,
      position = 'bottom-right',
      duration = 5000,
      pauseOnHover = true,
      pauseOnFocusLoss = true,
      icon = true,
      transition = Slide,
      ...props
    }) => {
      toast(
        ({ closeToast, toastProps }) => (
          <CustomNotification
            closeToast={closeToast}
            toastProps={toastProps}
            data={{ title, content: message }}
          />
        ),
        {
          type,
          data: {
            title,
            content: message
          },
          position,
          icon,
          theme: 'colored',
          transition,
          autoClose: duration,
          pauseOnHover,
          pauseOnFocusLoss,
          closeButton: true,
          closeOnClick: false,
          role: 'alert',
          ...props
        }
      );
    },
    []
  );

  return { addNotification };
};
